import { districtsPopupSlice } from '../slices/districtsPopup';
import { geoTagsSlice } from '../slices/geoTags';
import { highwaysSlice } from '../slices/highways';
import { jsonQuerySlice } from '../slices/jsonQuery';
import { listingSlice } from '../slices/listing';
import { locationSlice } from '../slices/location';
import { locationPopupSlice } from '../slices/locationPopup';
import { regionalDistrictsPopupSlice } from '../slices/regionalDistrictsPopup';
import { regionsSlice } from '../slices/regions';
import { searchMetaSlice } from '../slices/searchMeta';
import { undergroundMapSlice } from '../slices/undergroundMap/undergroundMapSlice';
import { userSlice } from '../slices/user';
import { villageNameSlice } from '../slices/villageName';

export const REDUCERS_MAP = {
  [districtsPopupSlice.name]: districtsPopupSlice.reducer,
  [geoTagsSlice.name]: geoTagsSlice.reducer,
  [highwaysSlice.name]: highwaysSlice.reducer,
  [jsonQuerySlice.name]: jsonQuerySlice.reducer,
  [listingSlice.name]: listingSlice.reducer,
  [locationSlice.name]: locationSlice.reducer,
  [locationPopupSlice.name]: locationPopupSlice.reducer,
  [regionalDistrictsPopupSlice.name]: regionalDistrictsPopupSlice.reducer,
  [regionsSlice.name]: regionsSlice.reducer,
  [searchMetaSlice.name]: searchMetaSlice.reducer,
  [undergroundMapSlice.name]: undergroundMapSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [villageNameSlice.name]: villageNameSlice.reducer,
};
